import graphql__7ac06cf765ee387ba2b5 from "./__generated__/PostSignUpFormRouteQuery.graphql.js";import { Component } from "react";
import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";

import PostSignUpForm from "../Profile/PostSignUpForm";

class PostSignUpFormRoute extends Component {
  render() {
    return (
      <AppQueryRenderer
        query={PostSignUpFormRouteQuery}
        component={PostSignUpForm}
        additionalProps={this.props}
      />
    );
  }
}

const PostSignUpFormRouteQuery = graphql__7ac06cf765ee387ba2b5;

export default PostSignUpFormRoute;
